import Header from "../components/Header";
import Footer from "../components/Footer";
import TitleBanner from "../components/titlebanner";
import Mission from "../components/Home/mission";
import Work from "../components/Home/work";
import ProjectSection from "../components/Projects/projectsection";

export default function Project() {
  return (
    <>
      <Header />
      <TitleBanner title={"Project List"}/>
      <ProjectSection/>
      <Work/>
      <Mission/>    
      <Footer />
    </>
  )
}
